import Lottie from "react-lottie-player";
import loading from "./calendar.json";

export const Loading = (props) => {
  return <Lottie animationData={loading} {...props} play />;
};
